import "./App.css";
import SuperTokens, { SuperTokensWrapper } from "supertokens-auth-react";
import { getSuperTokensRoutesForReactRouterDom } from "supertokens-auth-react/ui";
import { doesSessionExist, SessionAuth } from "supertokens-auth-react/recipe/session";
import { Routes, BrowserRouter as Router, Route } from "react-router-dom";
import { PreBuiltUIList, SuperTokensConfig, ComponentWrapper, navItems } from "./config";
import Home from "./components/Home";
import Practice from "./components/Practice/Practice";
import NavBar from "./components/NavBar/NavBar";
import Vocabs from "./components/Vocabs/Vocabs";
import { Title } from "./components/Misc/Title";
import Achievements from "./components/Achievements/Achievements";
import Info from "./components/Info/Info";
import Index from "./components/Index/Index";
import Streak from "./components/Streak/Streak";
import { EmailVerificationPreBuiltUI } from "supertokens-auth-react/recipe/emailverification/prebuiltui";
import { LegalNotice } from "./components/LegalTexts/LegalNotice";
import { CookiePolicy } from "./components/LegalTexts/CookiePolicy";
import { PrivacyPolicy } from "./components/LegalTexts/PrivacyPolicy";
import { useEffect, useState } from "react";
import authEventTarget from "./events/AuthEvents";
import { LoggingIn } from "./components/LogingIn/LogingIn";


SuperTokens.init(SuperTokensConfig);

function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const handleLogin = () => {setIsLoggedIn(true);}
        authEventTarget.addEventListener("loggedInEvent", handleLogin);

        const getIsLoggedIn = async() => {
            setIsLoggedIn(await doesSessionExist());
        }
        getIsLoggedIn();

        return () => {
            authEventTarget.removeEventListener("loggedInEvent", handleLogin);
        };
    }, []);

    return (
        <SuperTokensWrapper>
            <ComponentWrapper>
                <div className="App app-container">
                    <Router>
                        <div className="fill">
                            <div className="fill" id="home-container">
                                <Title items={navItems} />
                                {!isLoggedIn && <LoggingIn />}
                                <Routes>
                                    {/* This shows the login UI on "/auth" route */}
                                    {getSuperTokensRoutesForReactRouterDom(require("react-router-dom"), [...PreBuiltUIList, EmailVerificationPreBuiltUI])}

                                    <Route path="/" element={
                                        <Index />
                                    }/>

                                    <Route path="/aviso-legal" element={
                                        <LegalNotice/>
                                    }/>
                                    <Route path="/politica-de-privacidad" element={
                                        <PrivacyPolicy/>
                                    }/>
                                    <Route path="/politica-de-cookies" element={
                                        <CookiePolicy/>
                                    }/>

                                    <Route path="/info" element={
                                        <SessionAuth>
                                            <Info />
                                            <Streak />
                                        </SessionAuth>
                                    } />

                                    <Route path="/categorias" element={
                                        <SessionAuth>
                                            <Vocabs />
                                            <Streak />
                                        </SessionAuth>
                                    } />

                                    <Route path="/buscar" element={
                                        <SessionAuth>
                                            <Home />
                                            <Streak />
                                        </SessionAuth>
                                    } />

                                    <Route path="/practicar" element={
                                        <SessionAuth>
                                            <Practice />
                                            <Streak />
                                        </SessionAuth>
                                    } />

                                    <Route path="/logros" element={
                                        <SessionAuth>
                                            <Achievements />
                                            <Streak />
                                        </SessionAuth>
                                    } />
                                </Routes>
                                <NavBar key='nav-bar' items={navItems} />
                            </div>
                        </div>
                    </Router>
                </div>
            </ComponentWrapper>
        </SuperTokensWrapper>
    );
}

export default App;
